import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Select,
    Spinner,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import AiImageModal from 'components/aiHub/AiImageModal';
import AiVideoModal from 'components/aiHub/AiVideoModal';
import DriveModal from 'components/drive/DriveModal';
import { useFormik } from 'formik';
import { useState } from 'react';
import { BsStars } from 'react-icons/bs';
import PhoneInput from 'react-phone-input-2';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import { useUpdatePublishAdMutation } from 'store/publishTracking/trackingApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues } from 'utils/functions';
import * as Yup from 'yup';
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';
import FaceBookPageSelector from '../FaceBookPageSelector';
import InstagramAccountSelector from '../InstagramAccountSelector';
import UrlParametersUpdate from '../UrlParametersUpdate';
import PublishAdPreviews from './PublishAdPreviews';
import { MdOutlineEdit } from 'react-icons/md';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';


const SinglePublishAdupdate = ({ trackingData, targeting, onClose, onSaveSuccess }) => {
    const { adsAccount, form, _id, adset, campaign } = trackingData;
    const toast = useToast();
    const background = useColorModeValue('gray.50', 'gray.800');
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const [isDriveModalOpen, setIsDriveModalOpen] = useState(false);
    const [isEnabled, setIsEnabled] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const { isOpen: isAiImageModalOpen, onOpen: onAiImageModalOpen, onClose: onAiImageModalClose } = useDisclosure();
    const { isOpen: isAiVideoModalOpen, onOpen: onAiVideoModalOpen, onClose: onAiVideoModalClose } = useDisclosure();
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();

    const [updatePublishAd] = useUpdatePublishAdMutation();

    const pageId = adset?.promoted_object?.page_id || form?.identity?.page_id;

    const formattedPageIds = Array.isArray(pageId) ? pageId : [pageId];

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || !['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type)}
    );

    let pageIdToSend = null;

    if (
        ((adset?.destination_type === "PHONE_CALL" ||
        campaign?.objective === "OUTCOME_AWARENESS" ||
        adset?.destination_type === "ON_PAGE" ||
        adset?.destination_type === "WHATSAPP") && pageId)
    ) {
        pageIdToSend = pageId;
    }    

    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccount.adsAccountId}, {skip: !adsAccount.adsAccountId});

    // Validation Schema
    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Ad Name is required'),
        identity: Yup.object().shape({
            page_id: Yup.string().required('Facebook Page is required'),
        }),
        adcreative: Yup.object().shape({
            // message: Yup.string().required('Message is required'),
            name: Yup.string(),
            description: Yup.string(),
            type: Yup.string().required('Type is required'),
            link: Yup.string()
                .when('destinationType', {
                    is: (value) => ['WEBSITE', 'OUTCOME_AWARENESS', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(value),
                    then: () => Yup.string()
                        .required('URL is required'),
                    otherwise: () => Yup.string().notRequired(),
                }),
            phoneNumber: Yup.string().
                when('destinationType', {
                    is: (value) => ['PHONE_CALL', 'WEBSITE_AND_PHONE_CALL'].includes(value),
                    then: () => Yup.string()
                        .transform((value) => value.slice(2)) // Remove the first two digits (e.g., country code like "91")
                        .matches(/^[0-9]{10,15}$/, 'Phone number must be at least 10 digits') // Ensure remaining digits are at least 10 digits
                        .required('Phone number is required'), // Ensure phone number is provided
                    otherwise: () => Yup.string().notRequired(),
                })
        }),
    });

    const initialValues = {
        name: form.name || "",
        cpa: form.cpa || "",
        identity: {
            page_id: form?.identity?.page_id || "",
            instagram_user_id: form?.identity?.instagram_user_id || "",
        },
        destination_type: adset?.destination_type,
        adcreative: {
            page_welcome_message: form.adcreative?.page_welcome_message,
            _id: form.adcreative?._id || "",
            destinationType: campaign?.objective === "OUTCOME_AWARENESS" ? "OUTCOME_AWARENESS" : adset?.destination_type || "",
            message: form.adcreative?.message || "",
            url_tags: form?.adcreative?.url_tags || '',
            name: form.adcreative?.name || "",
            description: form.adcreative?.description || "",
            type: form.adcreative?.type || "",
            hash: form.adcreative?.hash || "",
            link: form.adcreative?.link || "",
            caption: form?.adcreative?.caption || '',
            lead_gen_form_id: form?.adcreative?.lead_gen_form_id || '',
            app_product_page_id: form.adcreative?.asset_feed_spec?.app_product_page_id,
            app_id: form?.adcreative?.template_url_spec?.config?.app_id || '',
            phoneNumber: adset?.destination_type ==='WEBSITE_AND_PHONE_CALL' ? form?.adcreative?.asset_feed_spec?.call_ads_configuration?.phone_number?.replace('tel:+', '') : form.adcreative?.link?.includes('tel:+') ? form.adcreative?.link.replace('tel:+', '') : '',
            video_id: form.adcreative?.video_id || "",
            thumbnail: form.adcreative?.thumbnail || "",
            image_hash: form.adcreative?.image_hash || "",
            url: form.adcreative?.url || "",
            enroll_status: form?.adcreative?.contextual_multi_ads?.enroll_status ? form?.adcreative?.contextual_multi_ads?.enroll_status : 'OPT_OUT',
            pac_relaxation_enroll_status:  form?.adcreative?.degrees_of_freedom_spec?.creative_features_spec?.pac_relaxation?.enroll_status || 'OPT_IN',
        },
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            const payload = {
                name: values.name,
                cpa: values.cpa,
                identity: {
                    page_id: values.identity.page_id,
                    ...(values?.identity?.instagram_user_id.trim() && {
                        instagram_user_id: values?.identity?.instagram_user_id,
                    }),
                },
                adcreative: {
                    contextual_multi_ads: {
                        enroll_status: values?.adcreative?.enroll_status,
                    },
                    _id: values.adcreative._id,
                    ...(values.adcreative.message?.trim() && { message: values.adcreative.message }),
                    name: values.adcreative.name,
                    description: values.adcreative.description,
                    type: values.adcreative.type,
                    link: values.adcreative.type === "CALL_NOW" ? `tel:+${values.adcreative.phoneNumber}` : values.adcreative.link,
                    lead_gen_form_id: values.adcreative.lead_gen_form_id,
                    ...((campaign?.objective === "OUTCOME_AWARENESS" || adset?.destination_type === "ON_VIDEO") && {
                        template_url_spec: { config: { app_id: values.adcreative.app_id } },
                    }),
                    ...((['WHATSAPP'].includes(adset?.destination_type)) && { page_welcome_message: values?.adcreative?.page_welcome_message }),
                    ...(
                        ["OUTCOME_AWARENESS","OUTCOME_TRAFFIC","OUTCOME_ENGAGEMENT","OUTCOME_SALES","OUTCOME_LEADS"].includes(campaign?.objective) && {
                          ...(!['CALL_NOW','LIKE_PAGE'].includes(values.adcreative.type) && { caption: values.adcreative.caption }),
                          ...(values.adcreative.type !== 'LIKE_PAGE' && !['WEBSITE_AND_PHONE_CALL','WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type) ? {
                            degrees_of_freedom_spec: {
                              creative_features_spec: {
                                pac_relaxation: { enroll_status: values.adcreative.pac_relaxation_enroll_status },
                              },
                            },
                          } : {}),
                        }
                    ),                      
                    ...(adset?.destination_type === 'WEBSITE_AND_PHONE_CALL' ? 
                            {
                                asset_feed_spec : {
                                    call_ads_configuration: {
                                        call_destination_type : "WEBSITE_AND_CALL",
                                        phone_number: `tel:+${values.adcreative.phoneNumber}`
                                    }
                                }
                            }
                        : {
                            asset_feed_spec: {
                                app_product_page_id: values.adcreative.app_product_page_id,
                            }
                        }
                    ),
                    ...(values.adcreative?.url_tags?.trim() && { url_tags: values.adcreative.url_tags }),
                    hash: values.adcreative.hash,
                    ...(formik.values.adcreative.video_id && {
                        video_id: values.adcreative.video_id,
                        thumbnail: values.adcreative.thumbnail,
                    }),
                    ...(formik.values.adcreative.image_hash && {
                        image_hash: values.adcreative.image_hash,
                        url: values.adcreative.url,
                    }),
                },
            };

            const filteredPayload = removeEmptyValues(payload);

            updatePublishAd({ trackingId: _id, payload: filteredPayload })
                .unwrap()
                .then(response => {
                    onSaveSuccess();
                    toast({
                        position: "top-right",
                        title: "Ad updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating ad",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    onClose();
                });
        },
    });
    const handleOpenDriveModal = () => {
        setIsDriveModalOpen(true);
    };

    const handleAiUploadedMedia = (data) => {
        const mappedMediaFiles = data.map(item => {
            const dynamicKeyData = item[item?.name] || {};

            return {
                creativeType: item?.creativeType,
                creativeId: item?.creativeId,
                source: item?.source,
                url: dynamicKeyData?.url || "",
                picture: dynamicKeyData?.url || "",
                hash: item?.hash,
                name: item?.name,
                adsAccount: {
                    adsAccountId: item?.adsAccount?.adsAccountId
                }
            };
        });

        if (mappedMediaFiles.length > 0) {
            const selectedFile = mappedMediaFiles[0];

            if (formik.values?.adcreative?.image_hash) {
                formik.setFieldValue('adcreative.image_hash', selectedFile?.creativeId);
                formik.setFieldValue('adcreative.url', selectedFile?.url);
                formik.setFieldValue('adcreative.hash', selectedFile?.hash);
            } else {
                formik.setFieldValue('adcreative.video_id', selectedFile?.creativeId);
                formik.setFieldValue('adcreative.thumbnail', selectedFile?.picture);
                formik.setFieldValue('adcreative.hash', selectedFile?.hash);
            }
        }
    };

    const handleMediaSelect = (file) => {
        if (file && file.length > 0) {
            const selectedFile = file[0];

            if (formik.values?.adcreative?.image_hash) {
                formik.setFieldValue('adcreative.image_hash', selectedFile?.creativeId);
                formik.setFieldValue('adcreative.url', selectedFile?.url);
                formik.setFieldValue('adcreative.hash', selectedFile?.hash);
            } else {
                formik.setFieldValue('adcreative.video_id', selectedFile?.creativeId);
                formik.setFieldValue('adcreative.thumbnail', selectedFile?.picture);
                formik.setFieldValue('adcreative.hash', selectedFile?.hash);
            }
        }
        setIsDriveModalOpen(false);
    };

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('adcreative.link', constructedUrl);
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('adcreative.url_tags', constructedUrl);
    };

    if (!trackingData || !formik.values) {
        return <Spinner mt={'20px'} />;
    }

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex gap={4}>
                <Flex direction={'column'} flex={0.4}>
                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Ad Name</Text>
                            <Input
                                name="name"
                                placeholder="Enter ad name"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.name}
                            />
                            {formik.touched.name && formik.errors.name && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.name}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Facebook Page</Text>
                            <FaceBookPageSelector
                                adsAccount={{
                                    account_id: adsAccount.adsAccountId,
                                    name: adsAccount.adsAccountName
                                }}
                                pageIdToSend={pageIdToSend ? pageIdToSend : ''}
                                selectedPageId={formik?.values?.identity?.page_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('identity.page_id', pageId);

                                    // Reset the Instagram actor ID to an empty string
                                    formik.setFieldValue('identity.instagram_user_id', '');
                                }}
                            />
                            {formik.errors.identity?.page_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.identity?.page_id}</Text>
                            )}
                        </Flex>

                        {adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Instagram accounts</Text>
                                <InstagramAccountSelector
                                    adsAccount={adsAccount}
                                    selectedInstPageId={formik?.values?.identity?.instagram_user_id}
                                    onSelectedPage={(pageId) => {
                                        formik.setFieldValue('identity.instagram_user_id', pageId);
                                    }}
                                    pageID={formik?.values?.identity?.page_id}
                                />
                            </Flex>
                        }
                    </Flex>
                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" mb={4} borderRadius="md" gap={2}>
                            <Checkbox
                                onChange={(e) => {
                                    formik.setFieldValue("adcreative.enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                }}
                                colorScheme="brand"
                                isChecked={formik.values.adcreative.enroll_status === 'OPT_IN'}
                            >
                                <Flex align={'center'}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Checkbox>
                        </Flex>

                        <Box>
                            <Text fontWeight="bold" mb={2}>Ad Creative</Text>
                            <Flex direction="row" gap={4} alignItems={'center'}>
                                <img
                                    src={formik.values.adcreative.image_hash ? formik.values.adcreative.url : formik.values.adcreative.thumbnail}
                                    alt={formik.values.adcreative.name}
                                    style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '5px' }}
                                />

                                <Flex direction={'column'} gap={2}>
                                    <Flex>
                                        <Button
                                            bg={background}
                                            size="xs"
                                            borderWidth={1}
                                            onClick={handleOpenDriveModal}>
                                            {formik.values?.adcreative?.image_hash ? "Change Image" : "Change Video"}
                                        </Button>
                                    </Flex>
                                    {formik.values?.adcreative?.image_hash ?
                                        <Flex alignItems={'center'} gap={2}>
                                            <Button
                                                colorScheme='brand'
                                                size="xs"
                                                onClick={onAiImageModalOpen}
                                                leftIcon={<BsStars />}
                                            >
                                                AI Image Generation
                                            </Button>

                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                                        <Text fontWeight={'bold'}>Generated with AI</Text>
                                                        <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                                        <Flex direction={'column'} gap={2}>
                                                            <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                            <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                            <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                                        </Flex>
                                                        <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        :
                                        <Flex alignItems={'center'} gap={2}>
                                            <Button
                                                colorScheme='brand'
                                                size="xs"
                                                onClick={onAiVideoModalOpen}
                                                leftIcon={<BsStars />}
                                            >
                                                AI Video Generation
                                            </Button>

                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                                        <Text fontWeight={'bold'}>Generated with AI</Text>
                                                        <Text>AI-generated video variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                                        <Flex direction={'column'} gap={2}>
                                                            <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                            <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                            <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                                        </Flex>
                                                        <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                    }
                                </Flex>
                            </Flex>

                            {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) &&  !['WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type) ? 
                                    <Flex direction={'column'} gap={2} mt={2}>
                                        <Flex alignItems="center">
                                            <Text fontWeight="bold" mr={2}>Flexible media</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Flex direction={'column'} fontSize="12px" p="5px" gap={2}>
                                                        <Text fontWeight={'bold'}>Flexible media</Text>
                                                        <Text>Show media that you chose for a specific aspect ratio across all placements when it's likely to improve performance. You can turn off flexible media at any time in ad creative.</Text>
                                                        <Text>To preview flexible media, select a specific placement group at the top of Ad preview.</Text>
                                                    </Flex>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Flex alignItems={'center'} gap={2}>
                                            <Switch colorScheme='brand' size={'sm'} isChecked={formik.values.adcreative.pac_relaxation_enroll_status === 'OPT_IN'} onChange={(e) => formik.setFieldValue('adcreative.pac_relaxation_enroll_status', e.target.checked ? 'OPT_IN' : 'OPT_OUT')} />
                                            <Text fontSize="12px">We'll deliver your media selections across your placements when it's likely to improve performance.</Text>
                                        </Flex>
                                    </Flex>
                            :null}

                        </Box>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Primary text</Text>
                            <Textarea
                                name="adcreative.message"
                                placeholder="Enter message"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.adcreative.message}
                            />
                            {formik.touched.adcreative?.message && formik.errors.adcreative?.message && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.message}</Text>
                            )}
                        </Flex>
                        
                        {adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Headline</Text>
                                <Input
                                    name="adcreative.name"
                                    placeholder="Write a short headline"
                                    size='sm'
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.adcreative.name}
                                />
                                {formik.touched.adcreative?.name && formik.errors.adcreative?.name && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.name}</Text>
                                )}
                            </Flex>
                        }   

                        {['APP','ON_PAGE'].includes(adset?.destination_type) ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Description</Text>
                                <Textarea
                                    name="adcreative.description"
                                    placeholder="Enter description"
                                    size='sm'
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.adcreative.description}
                                />
                            </Flex>
                        }

                        {adset?.destination_type === 'ON_PAGE' ? null :
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Call to action</Text>

                                {adset?.destination_type === 'PHONE_CALL' ? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                        isDisabled
                                    >
                                        <option value="CALL_NOW">Call Now</option>
                                    </Select>
                                ) : ['ON_AD', 'WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type) ? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                    >
                                        {call_to_action_options_instantForms?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adset?.destination_type === 'APP' && campaign?.objective === "OUTCOME_APP_PROMOTION" ? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                    >
                                        {call_to_action_options_app_promptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) :  adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                    >
                                        {call_to_action_options_for_app_leads_and_sales.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adset?.destination_type === 'WHATSAPP'  ? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                        isDisabled={campaign?.objective === 'OUTCOME_LEADS'}
                                    >
                                        {call_to_action_options_whatsapp.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : campaign?.objective === "OUTCOME_AWARENESS" || (["OUTCOME_ENGAGEMENT","OUTCOME_TRAFFIC"].includes(campaign?.objective) && adset?.destination_type === 'WEBSITE') || adset?.destination_type === 'ON_VIDEO'? (
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                    >
                                        {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : 
                                    <Select
                                        name="adcreative.type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.type}
                                    >
                                        {call_to_action_options.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                }

                                {formik.touched.adcreative?.type && formik.errors.adcreative?.type && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.type}</Text>
                                )}
                            </Flex>
                        }

                        {/* Show Website URL if destination_type supports WEBSITE or awareness objective */}
                        {(['WEBSITE', 'ON_VIDEO', 'WEBSITE_AND_PHONE_CALL', 'WEBSITE_AND_LEAD_FORM'].includes(adset?.destination_type) || campaign?.objective === 'OUTCOME_AWARENESS') && (
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Website URL</Text>
                            <Input
                            name="adcreative.link"
                            placeholder="Enter link URL"
                            size="sm"
                            borderRadius="md"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.adcreative.link}
                            />
                            <Flex mt={2}>
                            <Button
                                onClick={() => setUrlModalOpen(true)}
                                variant="link"
                                color="brand"
                            >
                                <Text fontSize="12px">Build a URL parameter</Text>
                            </Button>
                            </Flex>
                            {formik.touched.adcreative?.link && formik.errors.adcreative?.link && (
                            <Text fontSize="12px" color="red.500">
                                {formik.errors.adcreative?.link}
                            </Text>
                            )}
                        </Flex>
                        )}

                        {/* Show Phone Number if destination_type supports PHONE_CALL */}
                        {['PHONE_CALL', 'WEBSITE_AND_PHONE_CALL'].includes(adset?.destination_type) && (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Phone Number</Text>
                                <PhoneInput
                                name="adcreative.phoneNumber"
                                value={formik.values.adcreative.phoneNumber}
                                onChange={(value) => formik.setFieldValue('adcreative.phoneNumber', value)}
                                country={'in'}
                                />
                                {formik.errors.adcreative?.phoneNumber && (
                                <Text fontSize="12px" color="red.500">
                                    {formik.errors.adcreative?.phoneNumber}
                                </Text>
                                )}
                            </Flex>
                        )}

                        {adset?.destination_type === 'ON_AD' ? (
                            <>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('adcreative.link', value)} value={formik.values.adcreative.link} colorScheme="brand" mt={-2}>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td p={-1}>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500">No form data available</Text>
                                )}
                            </>
                        ) : adset?.destination_type === 'WEBSITE_AND_LEAD_FORM' ? (
                            <>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('adcreative.lead_gen_form_id', value)} value={formik.values.adcreative.lead_gen_form_id} colorScheme="brand" mt={-2}>
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px" p={-1}>Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td p={-1}>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500">No form data available</Text>
                                )}
                            </>
                        ) : adset?.destination_type === 'APP' && campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                    <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                    <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                    <Box>
                                                        <Text>* Android app link</Text>
                                                        <Text>* Custom URL scheme</Text>
                                                        <Text>* Facebook app link</Text>
                                                    </Box>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.link"
                                        placeholder="Enter a deferred deep link URL"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.link}
                                    />
                                </Flex>

                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                    <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                    <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.app_product_page_id"
                                        placeholder="Enter custom store listing ID"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.app_product_page_id}
                                    />
                                </Flex>
                            </>
                        ) : adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="adcreative.link"
                                        placeholder="Enter the deep link URL"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative.link}
                                    />
                                </Flex>
                            </>
                        ) : null}


                        {['WHATSAPP'].includes(adset?.destination_type) ? (
                            <>
                                <Flex>
                                    <Text fontWeight={'bold'}>Message template</Text>
                                </Flex>
                            
                                {(() => {
                                const welcomeData = formik?.values?.adcreative?.page_welcome_message;

                                const type = welcomeData?.text_format?.customer_action_type;

                                const greeting = welcomeData?.text_format?.message?.text || '';
                                const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                return (
                                    <Box>
                                        <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                            <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                            {type === 'autofill_message' && (
                                                <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                            )}

                                            {type === 'ice_breakers' && (
                                                <>
                                                <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                {iceBreakers.map((q, i) => (
                                                    <Text key={i} fontSize="14px">
                                                    {i + 1}. {q.title}
                                                    </Text>
                                                ))}
                                                </>
                                            )}
                                        </Box>

                                        <Button
                                            variant="outline"
                                            backgroundColor="transparent" 
                                            size={'sm'}
                                            leftIcon={<MdOutlineEdit />}
                                            mt={2}
                                            onClick={() => {
                                                onMessageModalOpen();
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Box>
                                );
                                })()}
                            </>
                        ) : null}

                        {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) &&  !['PHONE_CALL', 'APP', 'WHATSAPP'].includes(adset?.destination_type) ? 
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Display link</Text>
                                <Input
                                    name="adcreative.caption"
                                    placeholder="Enter the link that you want to show on your ad"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.adcreative.caption}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        : null}

                        {campaign?.objective === "OUTCOME_AWARENESS" || adset?.destination_type === 'ON_VIDEO'  ? 
                            <Flex direction={'column'} gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" >Mobile app</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name={`adcreative.app_id`}
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.adcreative?.app_id}
                                >
                                    <option value="">Choose app</option>
                                    {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                                </Select>
                            </Flex>
                        :null}

                    </Flex>

                    {['APP', 'PHONE_CALL', 'ON_PAGE', 'WHATSAPP'].includes(adset?.destination_type) ? null :
                        <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                            <Text fontWeight={'bold'}>Tracking</Text>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={2} fontWeight="bold">
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="adcreative.url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.adcreative.url_tags}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched.adcreative?.url_tags && formik.errors.adcreative?.url_tags && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative?.url_tags}</Text>
                                )}
                            </Flex>
                        </Flex>
                    }

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">CPA</Text>
                            <Input
                                name="cpa"
                                placeholder="Enter CPA"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.cpa}
                            />
                        </Flex>
                    </Flex>

                    <Flex mb={2}>
                        <Button
                            size="sm"
                            colorScheme="brand"
                            isLoading={formik.isSubmitting}
                            type="submit"
                            isDisabled={!formik.isValid}
                        >
                            Save
                        </Button>
                    </Flex>
                </Flex>

                <Flex flex={0.6} px={4} direction={'column'} justifyContent={'space-between'} borderRadius={'md'} boxShadow="0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)">
                    <Flex py={2} gap={2} direction={'column'}>
                        <Flex py={2} gap={2}>
                            <Switch isChecked={isEnabled} colorScheme='brand' onChange={() => setIsEnabled(prevState => !prevState)} />
                            <Text fontWeight={'bold'} fontSize={'14px'}>Ad preview  </Text>
                        </Flex>
                        <Divider />
                        {isEnabled &&
                            <PublishAdPreviews placements={targeting} file={formik.values} adsAccountData={adsAccount} />
                        }
                    </Flex>

                    <Flex my={2} alignItems={'center'}>
                        <Text fontSize={'12px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </Flex>
                </Flex>
            </Flex>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={formik.values.adcreative} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={formik.values.adcreative} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal
                isOpen={isAiImageModalOpen}
                onClose={onAiImageModalClose} scrollBehavior={"inside"}
                size={"5xl"}
                isCentered={true}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Image Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="sm" p="5px">
                                            <Text fontWeight={'bold'}>Generated with AI</Text>
                                            <Text>AI-generated image variations are inspired by your original asset. Adding multiple image options to your ad can help tailor creatives to different audiences, reduce creative fatigue, and improve overall performance.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Background Variation: Your product is placed in different, relevant environments.</Text>
                                                <Text>Creative Variation: Entirely new visuals generated based on your original creative.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated images.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <AiImageModal
                            selectedAdAccounts={[{
                                id: adsAccount._id,
                                adsAccountId: adsAccount.adsAccountId,
                                adsAccountName: adsAccount.adsAccountName,
                            }]}
                            onClose={onAiImageModalClose}
                            onUploadComplete={handleAiUploadedMedia}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Upload Video Modal */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isAiVideoModalOpen}
                scrollBehavior={"inside"}
                onClose={onAiVideoModalClose}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex gap={2} direction={'column'}>
                            <Flex alignItems={'center'} gap={2}>
                                <BsStars />
                                <Text>AI Video Generation</Text>
                                <Tooltip
                                    borderRadius={5}
                                    label={
                                        <Flex direction={'column'} gap={2} fontSize="12px" p="5px">
                                            <Text fontWeight={'bold'}>AI Video Generation</Text>
                                            <Text>AI-generated video ads are created using your product information and visuals. By assembling product highlights, voiceovers, and dynamic visuals, the AI helps generate high-performing video ads optimised for various platforms.</Text>
                                            <Flex direction={'column'} gap={2}>
                                                <Text fontWeight={'bold'}>Types of AI Variations:</Text>
                                                <Text>Product URL Based: Extracts product details from your URL to auto-generate video content.</Text>
                                                <Text>Asset Based: Uses your uploaded visuals to create fully edited video ads.</Text>
                                            </Flex>
                                            <Text>Note: Hustle does not guarantee the completeness, accuracy, or reliability of AI-generated videos.</Text>
                                        </Flex>
                                    }
                                    fontSize="md"
                                >
                                    <InfoOutlineIcon pointerEvents="all" />
                                </Tooltip>
                            </Flex>
                        </Flex>
                    </ModalHeader>
                    <ModalBody>
                        <AiVideoModal
                            isOpen={isAiVideoModalOpen}
                            selectedAdAccounts={[{
                                id: adsAccount._id,
                                adsAccountId: adsAccount.adsAccountId,
                                adsAccountName: adsAccount.adsAccountName,
                            }]}
                            onClose={() => {
                                onAiVideoModalClose();
                            }}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik.values?.adcreative?.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('adcreative.page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            {/* Drive Modal */}
            <DriveModal
                isDriveModalOpen={isDriveModalOpen}
                selectedAdAccounts={[{
                    id: adsAccount._id,
                    adsAccountId: adsAccount.adsAccountId,
                    adsAccountName: adsAccount.adsAccountName,
                }]}
                onClose={() => setIsDriveModalOpen(false)}
                onSubmit={handleMediaSelect}
                uploadPurpose="update"
                mediaType={formik.values?.adcreative?.image_hash ? 'image' : 'video'}
            />
        </form>
    );
};

export default SinglePublishAdupdate;
